module.exports = require('./helpers/bundle-url').getBundleURL('84S4Y') + "compass-banner-refresh.907247a1.svg";